import { Column } from "../../../../core/components/Column";
import guiaProveedoresData from "../../../../core/data/db_guia_proveedores.json";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Row } from "../../../../core/components/Row";
import { SectionCard } from "../../../../core/components/SectionCard";
import { Ref } from "../../../../core/components/Ref";
import { SocialLinks } from "../components/SocialLinks";

export const HomeScreen: React.FC = () => {
	const sections = Object.values(guiaProveedoresData);

	return (
		<>
			<Row
				className="relative w-full md:h-[40rem] gap-8"
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				responsiveCol
			>
				<div className="absolute w-full h-full">
					<img
						className="select-none w-full h-full object-cover"
						src="https://img.freepik.com/foto-gratis/planificador-bodas-femenino-trabajando-ceremonia_23-2150167261.jpg?t=st=1745557421~exp=1745561021~hmac=28e305de808b6e77f96a9efc6ef4014ff5d1cfa6ede17645ec6c04a6837fad33&w=996"
						draggable={false}
						alt="Dos personas organizando temas de bodas"
					/>
					<div className="absolute bg-black/60 w-full h-full z-[1] top-0" />
				</div>
				<Column className="w-4/5 sm:w-4/6 xl:w-[50rem] z-10 gap-4 py-32 md:py-48">
					<TextComponent
						variant="mediumBig"
						className="uppercase font-bold text-primaryPorcelain text-center font-isabel"
					>
						Guia de <span className="text-secondaryPurple">Proveedores</span>
					</TextComponent>
					<TextComponent
						variant="h1"
						className="font-baskerville font-bold text-primaryBlush italic text-center"
					>
						MEGABODAS - By Sinthia Flores
					</TextComponent>
					<TextComponent
						variant="h2"
						className="text-center text-primaryPorcelain/90 tracking-wide"
					>
						Sabemos lo importante que es cada detalle en tu <span className="text-darkPurple font-semibold">evento</span>, por eso preparé esta guía con algunos{" "}
						<span className="text-darkPurple font-semibold">proveedores</span> que pueden ayudarte a hacer tu día aún más especial.
						<br />
						<br />
						<span className="text-primaryBlush font-semibold uppercase">¡Disfruta del proceso y haz de tu evento algo inolvidable!</span>
					</TextComponent>
					<SocialLinks className="self-center" classNameIcon="w-6 h-6"/>
				</Column>
			</Row>
			<Row
				className="w-full gap-2 md:gap-4 p-5 mt-5 bg-white shadow"
				mainAxisAlignment="center"
				crossAxisAlignment="center"
			>
				<TextComponent
					variant="h1"
					className="font-baskerville font-bold text-center text-primarySunset "
				>
					Servicios de Proveedores para Bodas
				</TextComponent>
			</Row>
			<main className="self-center w-full sm:w-[40rem] md:w-[50rem] xl:w-[60rem] mb-4 sm:mb-8">
				<Column
					crossAxisAlignment="center"
					className="py-5 px-5 gap-5 min-h-screen"
				>
					<Column className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 w-full gap-4 sm:gap-8">
						{sections.map((section, index) => (
							<SectionCard
								key={index}
								index={index}
								img={section.imagen}
								titulo={section.titulo}
								descripcion={section.descripcion}
							>
								<Ref
									className="w-full font-bold mt-auto self-center"
									href={section.url}
									size="sm"
									color="ivory"
									secondary
								>
									<TextComponent variant="h5">Ver más</TextComponent>
								</Ref>
							</SectionCard>
						))}
					</Column>
				</Column>
			</main>
		</>
	);
};
